import { GET, POST } from "config/api.config";
import {
  ACCOUNT_EXECUTIVE_DASHBOARD,
  AI_PIPELINE_DASHBOARD,
  BACKEND_DASHBOARD,
  RECRUITER_DASHBOARD,
} from "../config/apiEndPoint";

/** GET dashboard/account-executive */
export const fetchAccountExecutiveDashboard = async () => {
  try {
    const response = await GET(ACCOUNT_EXECUTIVE_DASHBOARD.HOME);
    return response;
  } catch {
    return undefined;
  }
};

/** GET dashboard/account-executive/meta */
export const fetchAccountExecutiveDashboardMeta = async () => {
  try {
    const response = await GET(ACCOUNT_EXECUTIVE_DASHBOARD.META);
    return response;
  } catch {
    return undefined;
  }
};

/** GET dashboard/recruiter — optional `?viewAsUserId=` query when impersonating. */
export const fetchRecruiterDashboard = async (params = {}) => {
  try {
    const viewAsUserId = String(params?.viewAsUserId ?? "").trim();
    const url = viewAsUserId
      ? `${RECRUITER_DASHBOARD.HOME}?viewAsUserId=${encodeURIComponent(viewAsUserId)}`
      : RECRUITER_DASHBOARD.HOME;
    const response = await GET(url);
    return response;
  } catch {
    return undefined;
  }
};

/** GET dashboard/recruiter/view-as-options */
export const fetchRecruiterDashboardViewAsOptions = async () => {
  try {
    const response = await GET(RECRUITER_DASHBOARD.VIEW_AS_OPTIONS);
    return response;
  } catch {
    return undefined;
  }
};

/** GET dashboard/backend — optional `?viewAsUserId=` query when impersonating. */
export const fetchBackendDashboard = async (params = {}) => {
  try {
    const viewAsUserId = String(params?.viewAsUserId ?? "").trim();
    const url = viewAsUserId
      ? `${BACKEND_DASHBOARD.HOME}?viewAsUserId=${encodeURIComponent(viewAsUserId)}`
      : BACKEND_DASHBOARD.HOME;
    const response = await GET(url);
    return response;
  } catch {
    return undefined;
  }
};

/** GET dashboard/backend/view-as-options */
export const fetchBackendDashboardViewAsOptions = async () => {
  try {
    const response = await GET(BACKEND_DASHBOARD.VIEW_AS_OPTIONS);
    return response;
  } catch {
    return undefined;
  }
};

/** GET dashboard/backend/details/{reviewStatusId} */
export const fetchBackendDashboardDetails = async (reviewStatusId) => {
  const raw = String(reviewStatusId ?? "").trim();
  if (!raw) return undefined;

  try {
    const response = await GET(BACKEND_DASHBOARD.DETAILS(raw));
    return response;
  } catch {
    return undefined;
  }
};

/** POST dashboard/ai-pipeline/summary/filter */
export const fetchAiPipelineSummary = async (data = {}) => {
  try {
    const response = await POST(AI_PIPELINE_DASHBOARD.SUMMARY_FILTER, data);
    return response;
  } catch {
    return undefined;
  }
};

/** POST dashboard/ai-pipeline/summary-detail/filter */
export const fetchAiPipelineSummaryDetail = async (data = {}) => {
  try {
    const response = await POST(AI_PIPELINE_DASHBOARD.SUMMARY_DETAIL_FILTER, data);
    return response;
  } catch {
    return undefined;
  }
};

/** POST dashboard/ai-pipeline/client-pipeline/filter */
export const fetchAiPipelineClientPipeline = async (data = {}) => {
  try {
    const response = await POST(AI_PIPELINE_DASHBOARD.CLIENT_PIPELINE_FILTER, data);
    return response;
  } catch {
    return undefined;
  }
};

/** POST dashboard/ai-pipeline/needs-attention/filter */
export const fetchAiPipelineNeedsAttention = async (data = {}) => {
  try {
    const response = await POST(AI_PIPELINE_DASHBOARD.NEEDS_ATTENTION_FILTER, data);
    return response;
  } catch {
    return undefined;
  }
};
